import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./Policies.css";

export default function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="ijacna-policy-page-container">
      <header className="ijacna-policy-page-header">
        <h1>Privacy Policy</h1>
        <p>
          IJACNA is committed to protecting the privacy and confidentiality of
          authors, reviewers, and readers. This policy outlines how we collect
          and use your information.
        </p>
      </header>

      <section className="ijacna-policy-section">
        <h2>Information Collection</h2>
        <ul>
          <li>
            We collect only necessary personal data for submission and
            communication.
          </li>
          <li>
            No personal data is sold, rented, or disclosed to third parties.
          </li>
          <li>
            Cookies are used solely to enhance user experience and analytics.
          </li>
        </ul>
      </section>

      <section className="ijacna-policy-section alt-bg">
        <h2>Data Protection</h2>
        <ul>
          <li>
            All collected data is securely stored and protected from
            unauthorized access.
          </li>
          <li>Users can request data removal as per GDPR and related laws.</li>
          <li>
            Regular audits ensure compliance with international privacy
            standards.
          </li>
        </ul>
      </section>

      <div className="ijacna-policy-back-button-container">
        <Link to="/policies" className="ijacna-policy-back-button">
          ← Back to Policies
        </Link>
      </div>
    </div>
  );
}
